import React, { FunctionComponent } from 'react';
import { Form, Field } from 'react-final-form';
import i18next from 'i18next';

import Input from 'components/inputs/Input';
import { requiredValidation, emailValidation, composeValidators } from 'helpers/validations';

import { Subtitle, Title, ViewContainer, ViewContent } from 'styles/view';
import { FormButtonContainer, FormContent, FormSubmitButton } from 'styles/form';

import { IForgotPasswordViewProps } from './types';
import './i18n';

const ForgotPasswordView: FunctionComponent<IForgotPasswordViewProps> = (
  props: IForgotPasswordViewProps,
) => {
  const { onSubmit } = props;

  return (
    <ViewContainer auth data-testid="forgot-password-view">
      <ViewContent>
        <Title>{i18next.t<string>('FORGOT_PASSWORD:TITLE')}</Title>
        <Subtitle>{i18next.t<string>('FORGOT_PASSWORD:SUBTITLE')}</Subtitle>
        <Form
          onSubmit={onSubmit}
          render={({ handleSubmit, submitting, pristine }) => (
            <FormContent data-testid="forgot-password-form" onSubmit={handleSubmit}>
              <Field
                label={i18next.t<string>('FORGOT_PASSWORD:EMAIL')}
                name="email"
                render={Input}
                type="email"
                validate={composeValidators(requiredValidation, emailValidation)}
              />
              <FormButtonContainer>
                <FormSubmitButton disabled={pristine || submitting} type="submit">
                  {i18next.t<string>('FORGOT_PASSWORD:SUBMIT_BUTTON')}
                </FormSubmitButton>
              </FormButtonContainer>
            </FormContent>
          )}
        />
      </ViewContent>
    </ViewContainer>
  );
};

export default ForgotPasswordView;
